import styled from "styled-components";
import { colors } from "globalStyles";

export const Wrapper = styled.div`
  padding: 24px 0;

  h1 {
    font-size: 28px;
    font-weight: bold;
    color: ${colors.DARK_GRAY};
    margin-bottom: 8px;
  }

  .admin-dashboard__intro {
    font-size: 14px;
    font-weight: normal;
    color: ${colors.MEDIUM_GRAY};
    margin-bottom: 24px;
  }

  .admin-dashboard__sections {
    margin-top: 32px;
  }

  .admin-dashboard__coming-soon,
  .admin-dashboard__external {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    font-weight: normal;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.MEDIUM_GRAY};
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 16px;
`;

export const Card = styled.div`
  background: ${colors.WHITE};
  border: 1px solid ${colors.LIGHT_GRAY};
  border-radius: 8px;
  padding: 20px;
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
`;

// A navigable section card. Rendered via `as={Link}`, so it inherits Card's box
// styling while behaving as a router link (hover affordance + pointer).
export const CardLink = styled(Card)`
  display: block;
  text-decoration: none;
  cursor: pointer;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: ${colors.SILKBLUE};
  }
`;

export const Metric = styled.div`
  font-size: 32px;
  font-weight: bold;
  color: ${colors.DARK_GRAY};
  line-height: 1.1;
`;

export const MetricLabel = styled.div`
  font-size: 13px;
  font-weight: bold;
  color: ${colors.MEDIUM_GRAY};
`;
